import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

import { getMonitoringProjectList } from "../../redux/adminUnitReportSlice/adminUnitReportSlice";
import PMGProjectIcon from "../../assets/icons/pmg-project.svg";
import UnitWiseCostBarChart from "./UnitWiseCostBarChart";
import UnitWiseCostDoughnutChart from "./UnitWiseCostDoughnutChart";
import ProjectWiseCostBarChart from "./ProjectWiseCostBarChart";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const DMCharts = () => {

    const dispatch = useDispatch();

    const { monitoringProjectList } = useSelector((state) => state.unitReport);

    const [masterProjects, setMasterProjects] = useState([]);

    /* ---------------------------------------------------------------------- */
    /*                    SHARED PROJECT LIST (fetched once)                  */
    /* ---------------------------------------------------------------------- */

    useEffect(() => {
        let projects = monitoringProjectList;

        if (projects && !Array.isArray(projects)) {
            projects =
                projects.data ??
                projects.projects ??
                projects.data?.projects ??
                [];
        }

        if (!Array.isArray(projects)) {
            projects = [];
        }

        setMasterProjects(
            projects.map((project) => ({
                IO_NO: project.IO_NO,
                REV_NO: project.REV_NO,
                PROJ_NAME: project.PROJ_NAME,
                PROJECT_TYPE: project.PROJECT_TYPE,
            }))
        );

    }, [monitoringProjectList]);

    useEffect(() => {
        dispatch(
            getMonitoringProjectList({
                PROJECT_TYPE: "ALL",
            })
        );
    }, [dispatch]);

    /* ---------------------------------------------------------------------- */
    /*                                  RENDER                                */
    /* ---------------------------------------------------------------------- */

    return (

        <div className="pb-14">

            <div className="px-5 flex flex-col gap-6 pt-8">

                {/* HEADER */}

                <div className="flex gap-3">

                    <img src={PMGProjectIcon} alt="icon" />

                    <div>
                        <div className="font-inter font-semibold text-[24px] text-[#101828]">
                            DM Analytics Charts
                        </div>
                        <div className="text-gray-500 text-sm">
                            *  All figures are in Rs Crores or in Percent depending on selected filter.
                        </div>
                    </div>

                </div>

                {/* CHARTS - each fully independent (own filters, own fetch) */}

                {/* <UnitWiseCostBarChart masterProjects={masterProjects} /> */}

                <UnitWiseCostDoughnutChart masterProjects={masterProjects} />

                <ProjectWiseCostBarChart masterProjects={masterProjects} />

            </div>

        </div>

    );

};

export default DMCharts;